<template>
	<div>
		<v-layout wrap>
			<v-flex xs12 text-xs-center py-3 class="title-detail title-main"
				:style="`border-color:${$appColors.gray};color:${$appColors.primary}`"
			>
				{{ title }}
			</v-flex>
			<v-flex xs12 text-xs-center py-3 class="title-detail"
				:style="`border-color:${$appColors.gray};color:${$appColors.primary}`"
			>
				Seleccionar {{ quantity }} preguntas
			</v-flex>
			<template v-if="questions && questions.length > 0">
				<v-flex
					xs12 px-3 class="check-border"
					:style="`border-color:${$appColors.gray}`"
					v-for="question in questions"
					:key="question.id"
					:class="{ 'disabled' : question.disabled }"
				>
					<v-checkbox
						class="check-questions-list mt-0 py-2"
						color="success"
						:disabled="question.disabled"
						hide-details
						:label="question.name"
						v-model="question.selected"
						@change="$emit('on-change')"
					></v-checkbox>
				</v-flex>
			</template>
			<template v-else>
				No se encontraron preguntas para el factor {{ name }}
			</template>
		</v-layout>
	</div>
</template>

<script>
	export default {
		name: 'questions-list',
		props: {
			name: String,
			quantity: [Number, String],
			questions: {
				default: () => [],
				type: Array,
			},
			title: String,
		},
	};
</script>

<style lang="scss" scoped>
	.check-border {
		border-bottom: 1px solid;
	}

	.title-detail {
		font-size: size(small);
		text-transform: uppercase;

		&.title-main {
			font-family: font(bold);
			font-size: size(medium);
		}
	}

	.disabled {
		opacity: .5;
	}
</style>



// WEBPACK FOOTER //
// src/components/surveys/questions-list.vue